import { render, staticRenderFns } from "./ConsultationNoteDialog.vue?vue&type=template&id=73a6f1c4&scoped=true&lang=pug&"
import script from "./ConsultationNoteDialog.vue?vue&type=script&lang=js&"
export * from "./ConsultationNoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationNoteDialog.vue?vue&type=style&index=0&id=73a6f1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6f1c4",
  null
  
)

/* custom blocks */
import block0 from "./ConsultationNoteDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDivider,VRow,VSheet,VSkeletonLoader,VSpacer})
